import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

const BANNER_FIELDS: FieldSchema[] = [
  { key: 'image', label: 'Picture', type: 'image' },
  { key: 'title', label: 'Title', type: 'string' },
  { key: 'subtitle', label: 'Text', type: 'text' },
  { key: 'ctaText', label: 'Button text', type: 'string' },
  { key: 'ctaLink', label: 'Button link', type: 'string', default: '/shop' },
]

/** v1: lilac panel with the picture beside the text. v2: full-width picture with a plum wash and the text over it. */
export const schema: ComponentSchema = {
  type: 'lookbook-banner',
  label: 'Editorial banner',
  description: 'A picture with a title, text and one button.',
  supportedPages: ['home', 'shop', 'category'],
  variants: [
    {
      id: 'v1',
      label: 'Picture beside text',
      fields: [
        ...BANNER_FIELDS,
        {
          key: 'imagePosition',
          label: 'Picture side',
          type: 'select',
          options: [{ label: 'Left', value: 'left' }, { label: 'Right', value: 'right' }],
          default: 'left',
        },
      ],
    },
    {
      id: 'v2',
      label: 'Text over picture',
      fields: [...BANNER_FIELDS, { key: 'overlayOpacity', label: 'Dark wash (30–90)', type: 'number', default: 40 }],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
}
